/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown> }} User_LabelInputs */



/**
* | output |
* | --- |
* | "User: {user}" |
*
* @param {User_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const user_label = /** @type {((inputs: User_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Utilisateur : ${i?.user}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Benutzer: ${i?.user}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Utente: ${i?.user}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Пользователь: ${i?.user}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Usuario: ${i?.user}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`用户：${i?.user}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ユーザー: ${i?.user}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपयोगकर्ता: ${i?.user}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Usuário: ${i?.user}`)
	return /** @type {LocalizedString} */ (`User: ${i?.user}`)
});